export default {
    computed: {
        listFilters() {
            const filters = [
                {
                    key: 'deliveryTime',
                    inputType: 'checkbox',
                    label: 'labels.upcoming',
                    type: 'gt',
                    value: this.$date().format(),
                    blocker: 'deliveryTime',
                },
                {
                    key: 'deliveryTime',
                    inputType: 'checkbox',
                    label: 'labels.today_tomorrow_filter',
                    type: 'gt',
                    value: this.$date().startOf('day').format(),
                    other: {
                        key: 'deliveryTime',
                        type: 'lt',
                        value: this.$date().endOf('day').add(1, 'day').format(),
                    },
                    blocker: 'deliveryTime',
                    dateValidation: 'day',
                    default: true,
                },
                {
                    key: 'deliveryTime',
                    type: 'gt',
                    label: 'labels.delivery_time_from',
                    inputType: 'date',
                    listener: 'deliveryTime',
                    wider: true,
                },
                {
                    key: 'deliveryTime',
                    type: 'lt',
                    label: 'labels.delivery_time_until',
                    inputType: 'date',
                    listener: 'deliveryTime',
                    wider: true,
                },
            ]
            return filters
        },
    },
}
